import React, { useState, useEffect, useSyncExternalStore } from 'react';
import { Modal, Button, Form, Table, Dropdown } from 'react-bootstrap';
import { json, useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { backendURL } from '../IPaddress';
import '../CSS/CRUDfiles.css';
import Select from '../store/ThemedSelect';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useSchoolYear } from '../store/SchoolYearCalculator';
import ErrorModalMessage from '../store/ErrorMessage';
import {
  FilterBar,
  SearchInput,
  SortControl,
  ResultSummary,
  useListControls,
} from '../components/crud';

const WorkshopTeachersOBC = () => {
    const [eventsPrograms, setEventsPrograms] = useState([]);
    const [currentEventProgram, setCurrentEventProgram] = useState({
      event_template_id: null,
      name: null,
      description: '',
      location_id: null,
      coordinator_id: null,
      event_type_id: 3,
      obc_workshop_type_id: ''
    });
    const [currentEventDate, setCurrentEventDate ] = useState({
      event_dates_id: null,
      event_id: null, 
      date: null,
      start_time: null, 
      end_time: null,
      total_seats: null,
      sold_out: false,
    })
    const [ eventDates, setEventDates ] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [ showModalDateEvent, setShowModalDateEvent] = useState(false);
    const { authState } = useAuth();
    const [openStates, setOpenStates] = useState({});
    const navigate = useNavigate();
    const [ eventTypes, setEventTypes] = useState([]);
    const [ locations, setLocations] = useState([]);
    const [ userNames, setUsersNames] = useState([]);
    const [newDateModal, setNewDateModal] = useState(false);
    const [showEventDateModal, setShowEventDateModal] = useState(false);
    const [showDeletionError, setShowDeletionError] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [profileEvents, setProfileEvents] = useState([]);
    const [obcWorkshopTypes, setOBCWorkshopTypes ] = useState([]);
    const [teacherProfiles, setTeacherProfiles ] = useState([]);
    const [selectedTeachers, setSelectedTeachers ] = useState([]);
    const [selectedTeacher, setSelectedTeacher ] = useState([]);
    const [displayedSelectionTeachers, setDisplayedSelectionTeachers] = useState([]);
    const [schoolYearList, setSchoolYearList] = useState([]);
    const [selectedSchoolYear, setSelectedSchoolYear] = useState();
    const {currentYear, schoolYearListParent} = useSchoolYear();
  
  
    useEffect(() => {
      if (!authState) {
        navigate('/login');
      }
    }, [authState, navigate]);

    useEffect(() => {
      if (currentYear && schoolYearListParent.length) {
        setSelectedSchoolYear(currentYear);
        setSchoolYearList(schoolYearListParent);
      }
    }, [currentYear, schoolYearListParent]);

    useEffect(() => {
      if (selectedSchoolYear) {
        fetchEventsPrograms();
        fetchEventDates();
        fetchProfileEvents();
      }
    }, [selectedSchoolYear]);

  
    useEffect(() => {
      fetchEventTypes();
      fetchLocations();
      fetchUserNames();
      fetchOBCWorkshopTypes();
      fetchProfiles();
    }, []);
  
    const fetchEventsPrograms = async () => {
      try {const response = await fetch(`${backendURL}/api/events-programs/year/${selectedSchoolYear}`, {
        method: 'GET',
      //   credentials: 'include',
      });
      const data = await response.json();
      //filtering out classroom events
      const filteredEvents = data.filter(event => event.event_type_id === 3)
      // console.log("filtered data: ", filteredEvents)
      setEventsPrograms(filteredEvents);}
      catch {
        ErrorModalMessage('unable to fetch the program events')
      }
    };

    const fetchProfiles = async()=> {
      const response = await fetch (`${backendURL}/api/profiles`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response) {
        console.error('failed to fetch profiles');
      };
      const data = await response.json();
      setTeacherProfiles(data);
    }

    const fetchProfileEvents = async ()=> {
      const response = await fetch(`${backendURL}/api/profile-events/year/${selectedSchoolYear}`, {
        method:'GET',
        credentials: 'include'
      })
      if (!response){
        console.error('failed to fetch profile events');
      }
      const data = await response.json();
      setProfileEvents(data);
    };

    const fetchOBCWorkshopTypes = async ()=> {
      const response = await fetch(`${backendURL}/api/workshop_types`,{
        method:'GET',
        credentials: 'include'
      })
      if (!response) {
        console.error('failed to fetch the obc workshop types');
      }
      const data = await response.json();
      setOBCWorkshopTypes(data);
    };
  
    const fetchEventTypes = async () => {
      const response = await fetch(`${backendURL}/api/event-types`, {
        method: 'GET',
        credentials: 'include'
      });
      try{
        const data = await response.json();
        setEventTypes(data);
      } catch (error) {
        console.error("Error fetching the event types: ", error.message)
      }
    };

    const fetchUserNames = async () => {
      try {
          const response = await fetch (`${backendURL}/api/app-users`,{
              method: 'GET',
              credentials: 'include'
            });
          const data = await response.json();
          if(!response.ok) throw new Error ('Failed to fetch user data')
          // console.log("Users Data: ",data)
          setUsersNames(data);
      } catch (err) {
          console.error(err.message);
      }
    };

    const fetchLocations = async () => {
      const response = await fetch(`${backendURL}/api/locations`, {
        method: 'GET',
        credentials: 'include'
      });
      try{
        const data = await response.json();
        setLocations(data);
      } catch (error) {
        console.error("Error fetching locations: ", error.message)
      }
    };
  
    const fetchEventDates = async () => {
      try {const response = await fetch(`${backendURL}/api/event-dates/year/${selectedSchoolYear}`, {
          method: 'GET',
          credentials: 'include'
      });
      const data = await response.json();
      const sortedData = data.sort((a, b) => new Date(a.date) - new Date(b.date));
      setEventDates(sortedData);
      // console.log("event dates: ", data);
  
      }
      catch (error) {
          console.error("Error fetching event dates: ", error.message);
      }
    };
  
    const handleEventFormChange = (field, value, type = 'text') => {

      if(field === 'obc_workshop_type_id' || field === 'coordinator_id' || field === 'number_of_students') {
          setCurrentEventProgram(currentEventProgram => ({
              ...currentEventProgram, 
              [field]:parseInt(value, 10) || 0,
              school_year_id: parseInt(selectedSchoolYear, 10),
        }));
      }  else {    
        setCurrentEventProgram({
           ...currentEventProgram,
           [field]: value,
          school_year_id: parseInt(selectedSchoolYear, 10), });
      }
    };

    const handleTeacherChange = selectedOptions => {
      setSelectedTeachers(selectedOptions);
      const teacherIds = selectedOptions.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));

      selectedOptions.forEach(option => {
        const id = parseInt(option.value, 10);
        if (isNaN(id)) {
            console.warn(`Warning: could not parse school_id value "${option.value}" as an integer`);
        }
    });

    setSelectedTeacher(teacherIds)
  };
  

    const handleEventDateFormChange = (event) => {
      const { name, type, checked, value } = event.target;
  
      if (type === "checkbox") {
          // For checkboxes, use the `checked` property
          setCurrentEventDate(prevState => ({
              ...prevState,
              [name]: checked,
              school_year_id: parseInt(selectedSchoolYear, 10),
          }));
      } else if (type === "number") {
          // For number inputs, convert value to integer
          setCurrentEventDate(prevState => ({
              ...prevState,
              [name]: parseInt(value, 10),  // base 10 for decimal numbers
              school_year_id: parseInt(selectedSchoolYear, 10),
          }));
      } else {
          // For all other types, use the value directly
          setCurrentEventDate(prevState => ({
              ...prevState,
              [name]: value,
              school_year_id: parseInt(selectedSchoolYear, 10),
          }));
      }
  };
  
  
  
    const handleEventSubmit = async (e) => {
      e.preventDefault();
      const method = currentEventProgram.event_id ? 'PUT' : 'POST';
      const url = currentEventProgram.event_id ? `${backendURL}/api/events-programs/${currentEventProgram.event_id}` : `${backendURL}/api/events-programs`;
      await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(currentEventProgram),
        credentials: 'include',
      });
  
      setCurrentEventProgram({
        event_template_id: null,
        name: null,
        description: '',
        location_id: null,
        coordinator_id: null,
        event_type_id: 3,
        obc_workshop_type_id: ''
      });
      setShowForm(false);
      fetchEventsPrograms();
    };
  
      const handleNewEventDate = async (eventProgramId) => {
      setCurrentEventDate({
        event_dates_id: null,
        event_id: eventProgramId, 
        date: null, 
        start_time: null, 
        end_time: null,
        total_seats: null,
        sold_out: false,
      });
      setShowEventDateModal(true); // Use the same modal for creating a new event date
    };
  
    const handleEventDateSubmit = async (e) => {
      e.preventDefault();
      const method = currentEventDate.event_dates_id ? 'PUT' : 'POST';
      const url = currentEventDate.event_dates_id ? `${backendURL}/api/event-dates/${currentEventDate.event_dates_id}` : `${backendURL}/api/event-dates`;
      const dateResponse = await fetch(url, {
          method: method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(currentEventDate),
          credentials: 'include',
      });
  
      if (!dateResponse.ok) {
          throw new Error('Failed to create event date for the related program.');
      }
      const newDateResponse = await dateResponse.json();
      // console.log('selected school year: ', selectedSchoolYear);
  
      // Belt-and-braces: drop any selected teachers whose profile has no school
      // (e.g. stale selections made before the school was removed from the profile).
      const eligibleProfileIds = new Set(
        teacherProfiles
          .filter(profile => profile.school_id !== null && profile.school_id !== undefined && profile.school_id !== '')
          .map(profile => profile.profile_id)
      );
      const eligibleSelectedTeacherIds = selectedTeacher.filter(id => eligibleProfileIds.has(id));

      const payload = {
          event_id: newDateResponse.event_dates_id,
          profile_id: eligibleSelectedTeacherIds,
          school_year_id: parseInt(selectedSchoolYear, 10),
      };
  
      // console.log('payload: ', payload);
  
      const eventDateProfileUrl = `${backendURL}/api/profile-events${currentEventDate.event_dates_id ? `/${currentEventDate.event_dates_id}` : ''}`;
      const eventDateProfile = await fetch(eventDateProfileUrl, {
          method: method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'include'
      });
  
      if (!eventDateProfile.ok) {
          throw new Error('Failed to create event date profile for the event and program.');
      }
  
      setCurrentEventDate({
          event_dates_id: null,
          event_id: null,
          date: null,
          start_time: null,
          end_time: null,
          total_seats: null,
          sold_out: false,
      });
      setShowEventDateModal(false);
      setShowModalDateEvent(false);
      setNewDateModal(false);
      fetchEventDates();
      fetchProfileEvents();
      setSelectedTeachers([]);
      setSelectedTeacher([]);
  };
  
  
    const editEventProgram = (eventProgram) => {
      setCurrentEventProgram(eventProgram);
      setShowForm(true);
    };

    // Teachers must have a school on their profile before they can be added to a workshop.
    const eligibleTeacherProfiles = teacherProfiles.filter(
      profile => profile.school_id !== null && profile.school_id !== undefined && profile.school_id !== ''
    );
    const hiddenTeacherCount = teacherProfiles.length - eligibleTeacherProfiles.length;

    const teacherOptions = teacherProfiles.map(teacherProfile => {
      return{
        label: `${teacherProfile.first_name} ${teacherProfile.last_name}`,
        value: teacherProfile.profile_id
      }
    })

    const getTeachersOnDate = (eventDateId) => {
  
      // Retrieve relevant profiles for the event date
      const listProfileObjs = profileEvents.filter(profileEvent => profileEvent.event_id === eventDateId);
  
      // Map these profiles to options with labels from teacherProfiles
      const listOptions = listProfileObjs.map(profileEvent => {
          const teacher = teacherProfiles.find(profile => profile.profile_id === profileEvent.profile_id[0]);
          if (teacher){return {
              value: profileEvent.profile_id,
              label: teacher ? `${teacher.first_name} ${teacher.last_name}` : `Unknown Teacher`
          };}
      });
      console.log("teachers set for display: getTeachersOnDate", listOptions)
      setDisplayedSelectionTeachers(listOptions);
  }; // will need to take a look at this again. 

  const getTeachersForDate = (eventDateId) => {
    // Filter event dates to find those that match the given eventDateId
    const eventDateObjs = eventDates.filter(eventDate => eventDate.event_id === eventDateId);
    
    // Check if any event dates were found
    if (eventDateObjs.length > 0) {
      // Extract event_dates_id from each found event date object
      const eventDatesIds = eventDateObjs.map(eventDate => eventDate.event_dates_id);
      
      // Filter profileEvents to find those where event_id matches any of the extracted event_dates_ids
      const profileEventObjs = profileEvents.filter(profileEvent => 
        eventDatesIds.includes(profileEvent.event_id)
      );
      
      if (profileEventObjs.length > 0) {
        // Flatten the profile_ids from the filtered profile events
        const profileIds = profileEventObjs.flatMap(profileEvent => profileEvent.profile_id);
        
        // Filter teacher profiles where profile_id is in any of the flattened profile_ids
        const listOfTeachers = teacherProfiles.filter(teacher => 
          profileIds.includes(teacher.profile_id)
        );
  
        // Returning JSX directly in a function like this assumes it's part of a React component
        return (
          <ul>
            {listOfTeachers.map(teacher => 
              <li key={teacher.profile_id}>{teacher.first_name} {teacher.last_name}</li>
            )}
          </ul>
        );
      } else {
        
        return <p>No Teachers assigned to dates.</p>;
      }
    } else {
      
      return <p>No dates found.</p>;
    }
  }
  
  
  
    const editEventDate = (eventDate) => {

      const eventDateTeachersObj = profileEvents.filter(
        eventProfile => eventProfile.event_id === eventDate.event_dates_id
      );

      const listOfTeachers = eventDateTeachersObj.flatMap(eventProfile =>
        teacherOptions.filter(teacherOption => eventProfile.profile_id.includes(teacherOption.value))
      );

      if (listOfTeachers.length) {

        const teacherIds = listOfTeachers.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));

        setSelectedTeachers(listOfTeachers);
        setSelectedTeacher(teacherIds);
      } else {
        setSelectedTeachers([]);
        setSelectedTeacher([]);
      }

      setCurrentEventDate({...eventDate});
      // getTeachersOnDate(eventDate.event_dates_id);
      setShowEventDateModal(true); // Use the same modal for editing an existing event date
    };
  
    const handleCancel = () => {
      setCurrentEventDate({
          event_dates_id: null,
          event_id: null, 
          date: null,
          start_time: null, 
          end_time: null,
          total_seats: null,
          sold_out: false,
        });
      setCurrentEventProgram({
          event_template_id: null,
          name: null,
          description: '',
          location_id: null,
          coordinator_id: null,
          event_type_id: 3,
          obc_workshop_type_id: ''
        });
      setShowForm(false);
      setShowEventDateModal(false);
      setShowModalDateEvent(false);
      setNewDateModal(false);
      setSelectedTeachers([]);
      setSelectedTeacher([]);
    }
  
    const handleShowForm = () => {
      setCurrentEventProgram({
        event_template_id: null,
        name: null,
        description: '',
        location_id: null,
        coordinator_id: null,
        event_type_id: 3,
        obc_workshop_type_id: ''
      });
      setShowForm(!showForm);
    }
  
    const deleteEventProgram = async (event_id) => {
      
       try {
        const response = await fetch(`${backendURL}/api/events-programs/${event_id}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (response.ok) {
        fetchEventsPrograms();
      } else {
        console.log("Unable to delete the associated event");
      }
    }
      catch (error) {
        setShowDeletionError(true);
        console.error("Please delete associated event dates before deleting an event.");
      }
      setSelectedTeacher([]);
    };
  
    const handleDeleteEventDate = () => {
      setConfirmationMessage('Are you sure you want to delete this event date?')
      setShowConfirmationModal(true);
    }
    
    const deleteEventDate = async (eventDateId) => {
      try {
        const response = await fetch(`${backendURL}/api/event-dates/${eventDateId}`, {
          method: 'DELETE',
          credentials: 'include'
        });
        if (response.ok) {
          // Close modal and refresh the event dates list
          setShowEventDateModal(false);
          setShowConfirmationModal(false);
          setSelectedTeachers([]);
          setSelectedTeacher([]);
          fetchProfileEvents();
          fetchEventDates();    
        } else {
          throw new Error('Failed to delete the event date');
        }
      } catch (error) {
        console.error("Deletion failed:", error);
        // Optionally, handle error showing in UI
      }
    }
  
    const getEventType = (workshopTypeID) => {
      const workshopType = obcWorkshopTypes.find(eventType => eventType.type_id === workshopTypeID);
      return workshopType ? (<>{workshopType.name}</>) : 'workshop type failed to load';
    }
  
  
    const getLocation = (locationId) => {
      const locationObj = locations.find(location => location.location_id === locationId);
      return locationObj ? (<>{locationObj.name}</>) : 'Event type failed to load';
    }
  
    const getCoordinatorId = (userId) => {
      const nameObject = userNames.find(user => user.user_id === userId);
      return nameObject ? (`${nameObject.first_name} ${nameObject.last_name}`) : 'Coordinator not assigned';
  }
  
    const formatTime = (timeString) => {
      // Assuming timeString is in 'HH:MM:SS' format
      if (timeString === null) {
        return `no time set`;
      }
  
      const [hours, minutes] = timeString.split(':');
      const hoursInt = parseInt(hours, 10);
      const suffix = hoursInt >= 12 ? 'PM' : 'AM';
      const formattedHours = ((hoursInt + 11) % 12 + 1); // Convert 24hr to 12hr format
      return `${formattedHours}:${minutes} ${suffix}`;
    };
  
    const getProgramEventDates = (eventId) =>
      eventDates
        .filter(eventDate => eventDate.event_id === eventId)
        .sort((a, b) => new Date(a.date) - new Date(b.date));

    const getDateTeacherNames = (eventDatesId) => {
      const profileIds = profileEvents
        .filter(pe => pe.event_id === eventDatesId)
        .flatMap(pe => pe.profile_id);
      return teacherProfiles
        .filter(teacher => profileIds.includes(teacher.profile_id))
        .map(teacher => `${teacher.first_name} ${teacher.last_name}`);
    };

    const getTeacherCountForProgram = (eventId) => {
      const dateIds = getProgramEventDates(eventId).map(d => d.event_dates_id);
      const profileIds = new Set();
      profileEvents
        .filter(pe => dateIds.includes(pe.event_id))
        .forEach(pe => [].concat(pe.profile_id).forEach(id => profileIds.add(id)));
      return profileIds.size;
    };

    const getProgramScheduleSummary = (eventId) => {
      const programDates = getProgramEventDates(eventId);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const upcoming = programDates.find(d => d.date && new Date(d.date) >= today);
      const latest = programDates.length ? programDates[programDates.length - 1] : null;
      return {
        dateCount: programDates.length,
        nextDate: upcoming?.date || 'No upcoming dates',
        latestDate: latest?.date || 'No dates added',
        teacherCount: getTeacherCountForProgram(eventId),
      };
    };

    const renderEventDates = (eventProgram) => {
      const programDates = getProgramEventDates(eventProgram.event_id);
      if (programDates.length === 0) {
        return (
          <div className="schedule-empty-state">
            No dates have been created for this workshop yet.
          </div>
        );
      }
      return (
        <div className="schedule-card-grid">
          {programDates.map(eventDate => {
            const teacherNames = getDateTeacherNames(eventDate.event_dates_id);
            const teacherPreview = teacherNames.slice(0, 3).join(', ');
            return (
              <button
                type="button"
                key={eventDate.event_dates_id}
                className="schedule-card"
                onClick={() => editEventDate(eventDate)}
              >
                <div className="schedule-card-header">
                  <span className="schedule-card-title">{eventDate.date || 'No date set'}</span>
                </div>
                <div className="schedule-card-time">
                  {`${formatTime(eventDate.start_time)} to ${formatTime(eventDate.end_time)}`}
                </div>
                <div className="schedule-card-meta">
                  {`${teacherNames.length} teacher${teacherNames.length === 1 ? '' : 's'} assigned`}
                </div>
                <div className="schedule-card-preview">
                  {teacherPreview || 'No teachers assigned yet'}
                  {teacherNames.length > 3 ? '…' : ''}
                </div>
              </button>
            );
          })}
        </div>
      );
    }

    const toggleOpenState = (eventId) => {
      setOpenStates((prevOpenStates) => ({
        ...prevOpenStates,
        [eventId]: !prevOpenStates[eventId],
      }));
    };

    const handleYearChange = (event) => {
      setSelectedSchoolYear(event.target.value);
    };

    const {
      items: visibleEventsPrograms,
      resultCount,
      totalCount,
      isFiltered,
      search,
      sort,
      clear,
    } = useListControls(eventsPrograms, {
      searchAccessor: (eventProgram) =>
        [eventProgram.name, eventProgram.description].filter(Boolean).join(' '),
      sortOptions: [
        {
          key: 'name',
          label: 'Name',
          accessor: (eventProgram) => eventProgram.name?.toLowerCase() ?? '',
        },
        {
          key: 'location',
          label: 'Location',
          accessor: (eventProgram, ctx) => {
            const locationObj = ctx.locations.find(
              (location) => location.location_id === eventProgram.location_id
            );
            return (locationObj ? locationObj.name : 'Event type failed to load').toLowerCase();
          },
        },
      ],
      context: { locations },
    });


    return (
      <div>
        <Button onClick={() => handleShowForm()} className="m-1">
          {showForm ? 'Show OBC Workshops List' : 'Add New Workshop'}
        </Button>
        <div>
          <Dropdown>
          <span className='fw-bold'>Select School Year</span>
          <select value={selectedSchoolYear} onChange={handleYearChange}>
              <option value="" disabled>Select School Year</option>
              {schoolYearList.map((year) => (
                <option key={year.id} value={year.id}>
                  {year.school_year}
                </option>
              ))}
            </select>
          </Dropdown>
      </div>  
        {showForm ? (
          <Form onSubmit={handleEventSubmit}>
  
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter event name"
                name="name"
                value={currentEventProgram.name}
                onChange={e => handleEventFormChange('name', e.target.value)}
              />
            </Form.Group>
  
            <Form.Group controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter event description"
                name="description"
                value={currentEventProgram.description}
                onChange={e => handleEventFormChange('description', e.target.value)}
              />
            </Form.Group>
  
            <Form.Group controlId="location_id">
              <Form.Label>Location ID</Form.Label>
              <Form.Control
                as={'select'}
                name="location_id"
                value={currentEventProgram.location_id}
                onChange={e => handleEventFormChange('location_id', e.target.value)}
              >
                <option value={null}>{"Select Location"}</option>
              {locations.map( location => (
              <option key={location.location_id} value={location.location_id}>{location.name}</option>
              ))}
              </Form.Control>
            </Form.Group>
  
            <Form.Group controlId="coordinator_id">
              <Form.Label>Coordinator ID</Form.Label>
              <Form.Control
                as={'select'}
                name="coordinator_id"
                value={currentEventProgram.coordinator_id}
                onChange={e => handleEventFormChange('coordinator_id', e.target.value)}
              >
                <option value={''}>Select Coordinator</option>
                {userNames.map(userName => (
                  <option value={userName.user_id} key={userName.user_id}>{userName.first_name} {userName.last_name}</option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group controlId='number_of_students'>
              <Form.Label>Number of Students</Form.Label>
              <Form.Control
              type={'number'}
              name='number_of_students'
              value={currentEventProgram.number_of_students}
              onChange={e => handleEventFormChange('number_of_students', e.target.value)}>

              </Form.Control>
            </Form.Group>

  
            <Form.Group controlId="obc_workshop_type_id">
              <Form.Label>Workshop Type</Form.Label>
              <Form.Control
                as={'select'}
                name="obc_workshop_type_id"
                value={currentEventProgram.obc_workshop_type_id}
                onChange={e => handleEventFormChange('obc_workshop_type_id', e.target.value)}
                required
              >
                <option value={""}>Select Workshop Type</option>
                {obcWorkshopTypes.map(eventType => (
                  <option key={eventType.type_id} value={eventType.type_id}>{eventType.name}</option>
                ))}
              </Form.Control>
              </Form.Group>
  
            <Button type="submit" className="m-1">Submit</Button>
            <Button variant="secondary" className="m-1" onClick={handleCancel}>Cancel</Button>
          </Form>
        ) : (
          <>
            <FilterBar
              summary={(
                <ResultSummary
                  count={resultCount}
                  total={totalCount}
                  noun="workshop"
                  onClear={clear}
                  isFiltered={isFiltered}
                />
              )}
            >
              <SearchInput
                label="Search Workshops"
                placeholder="Search by workshop name or description"
                {...search}
              />
              <SortControl {...sort} />
            </FilterBar>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Teacher Workshops</th>
                </tr>
              </thead>
              <tbody>
                {visibleEventsPrograms.length === 0 ? (
                  <tr>
                    <td>
                      <div className="schedule-empty-state">
                        No teacher workshops match the current filters.
                      </div>
                    </td>
                  </tr>
                ) : visibleEventsPrograms.map((eventProgram) => {
                  const isOpen = openStates[eventProgram.event_id] || false;
                  const summary = getProgramScheduleSummary(eventProgram.event_id);
                  const rowDateSummary =
                    summary.dateCount === 0
                      ? 'No dates added'
                      : summary.nextDate !== 'No upcoming dates'
                        ? `Next: ${summary.nextDate}`
                        : `Most recent: ${summary.latestDate}`;

                  return (
                    <React.Fragment key={eventProgram.event_id}>
                      <tr
                        className={`compact-row${isOpen ? ' is-open' : ''}`}
                        onClick={() => toggleOpenState(eventProgram.event_id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td colSpan={1}>
                          <div className="event-program-row-content">
                            <div className="event-program-main">
                              <div className="event-program-name">{eventProgram.name || 'Untitled workshop'}</div>
                              <div className="event-program-type">{getEventType(eventProgram.obc_workshop_type_id)}</div>
                              <div className="event-program-description">
                                {eventProgram.description || 'No description provided.'}
                              </div>
                            </div>

                            <div className="event-program-row-meta">
                              <span className="compact-pill">{getLocation(eventProgram.location_id)}</span>
                              <span className="compact-pill">{getCoordinatorId(eventProgram.coordinator_id)}</span>
                              <span className="compact-pill">{summary.dateCount} Date{summary.dateCount === 1 ? '' : 's'}</span>
                              <span className="compact-pill">{eventProgram.number_of_students || 0} Students</span>
                            </div>

                            <div className="event-program-row-schedule">
                              <small>{rowDateSummary}</small>
                              <small>{`${summary.teacherCount} teacher${summary.teacherCount === 1 ? '' : 's'} assigned`}</small>
                            </div>

                            <div className="event-program-row-flags">
                              <span className="event-access-badge private">
                                {getEventType(eventProgram.obc_workshop_type_id)}
                              </span>
                              <span className="event-access-copy">
                                Admins assign teachers to each workshop date.
                              </span>
                            </div>

                            <div className="text-muted small event-program-expand">
                              {isOpen ? '▼ Collapse' : '▶ Expand'}
                            </div>
                          </div>
                        </td>
                      </tr>

                      {isOpen && (
                        <tr>
                          <td colSpan={1}>
                            <div className="event-program-detail-grid p-3 border rounded">
                              <div className="detail-panel">
                                <h6 className="mb-2">Overview</h6>
                                <div className="schedule-summary-row">
                                  <strong>Location</strong>
                                  <span>{getLocation(eventProgram.location_id)}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Coordinator</strong>
                                  <span>{getCoordinatorId(eventProgram.coordinator_id)}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Workshop Type</strong>
                                  <span>{getEventType(eventProgram.obc_workshop_type_id)}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Students</strong>
                                  <span>{eventProgram.number_of_students || 0}</span>
                                </div>
                                <div className="mt-2 text-muted small">
                                  {eventProgram.description || 'No description provided.'}
                                </div>
                              </div>

                              <div className="detail-panel">
                                <h6 className="mb-2">Schedule Summary</h6>
                                <div className="schedule-summary-row">
                                  <strong>Dates</strong>
                                  <span>{summary.dateCount}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Next Date</strong>
                                  <span>{summary.nextDate}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Most Recent</strong>
                                  <span>{summary.latestDate}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Teachers Assigned</strong>
                                  <span>{summary.teacherCount}</span>
                                </div>
                              </div>

                              <div className="detail-panel">
                                <h6 className="mb-2">Teachers</h6>
                                {getTeachersForDate(eventProgram.event_id)}
                              </div>

                              <div className="detail-panel actions-panel">
                                <h6 className="mb-2">Actions</h6>
                                <Button type="button" onClick={() => editEventProgram(eventProgram)}>
                                  <i className="bi bi-pencil"></i> Edit Workshop
                                </Button>
                                <Button type="button" onClick={() => handleNewEventDate(eventProgram.event_id)}>
                                  New Date
                                </Button>
                                <Button type="button" variant="danger" onClick={() => deleteEventProgram(eventProgram.event_id)}>
                                  <i className="bi bi-trash3"></i> Delete Workshop
                                </Button>
                              </div>

                              <div className="detail-panel event-program-dates-detail">
                                <div className="schedule-panel-toolbar">
                                  <div>
                                    <div className="schedule-panel-title">Dates for {eventProgram.name}</div>
                                    <div className="schedule-panel-subtitle">
                                      Each date lists the teachers assigned to that workshop session.
                                    </div>
                                  </div>
                                  <Button type="button" onClick={() => handleNewEventDate(eventProgram.event_id)}>
                                    New Date
                                  </Button>
                                </div>
                                {renderEventDates(eventProgram)}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
          <Modal show={showEventDateModal} onHide={() => handleCancel()}>
            <Modal.Header>{currentEventDate.event_dates_id ? 'Edit Event Date' : 'Create New Event Date'}</Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group>
                  <Form.Label>Select Date</Form.Label>
                  <Form.Control
                  type={'date'}
                  id='date'
                  name='date'
                  value={currentEventDate.date}
                  onChange={handleEventDateFormChange}>
                  </Form.Control>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Start Time</Form.Label>
                  <Form.Control
                  type={'time'}
                  id='start_time'
                  name='start_time'
                  value={currentEventDate.start_time}
                  onChange={handleEventDateFormChange}>
                  </Form.Control>
                </Form.Group>
                <Form.Group>
                  <Form.Label>End Time</Form.Label>
                  <Form.Control
                  id='end_time'
                  value={currentEventDate.end_time}
                  type={'time'}
                  name='end_time'
                  onChange={handleEventDateFormChange}>
                  </Form.Control>
                </Form.Group>
              <Form.Group controlId="teacherId">
                  <Form.Label>Teacher(s)</Form.Label>
                  <Select
                      isMulti
                      isSearchable={true}
                      options={eligibleTeacherProfiles.map(profile =>
                        ({ value: profile.profile_id, label: (`${profile.first_name} ${profile.last_name}`) }))}
                      value={selectedTeachers}
                      onChange={handleTeacherChange}
                      classNamePrefix="select"
                  />
                  {hiddenTeacherCount > 0 && (
                    <Form.Text className="text-muted">
                      {hiddenTeacherCount} teacher profile{hiddenTeacherCount === 1 ? '' : 's'} hidden — add a school to the profile to include them.
                    </Form.Text>
                  )}
              </Form.Group>
  
              </Form>
              <Modal.Footer className='modal-footer-buttons'>
                {currentEventDate.event_dates_id ? 
                <Button variant='danger' onClick={() => {handleDeleteEventDate()}}>Delete</Button>
                 : 
                 ''}
                <Button  onClick={handleEventDateSubmit}>{currentEventDate.event_dates_id ? 'Update' : 'Create'}</Button>
                <Button variant='secondary' onClick={() => handleCancel()}>Cancel</Button>
             </Modal.Footer>
            </Modal.Body>
          </Modal>
          <Modal show={showDeletionError} onHide={() => {setShowDeletionError(false)}}>
            <Modal.Header>Unable to process Request</Modal.Header>
            <Modal.Body>Please be sure to delete all associated dates with the event before deleting the event</Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={() => setShowDeletionError(false)}>Close</Button>
            </Modal.Footer>
          </Modal>
          <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
            <Modal.Header closeButton>{'Please Confirm!'}</Modal.Header>
            <Modal.Body>{confirmationMessage}</Modal.Body>
            <Modal.Footer>
              <Button variant='danger' onClick={() => deleteEventDate(currentEventDate.event_dates_id)}>{'Delete'}</Button>
              <Button variant='secondary' onClick={() => setShowConfirmationModal(false)}>{'Cancel'}</Button>
            </Modal.Footer>
          </Modal>
  
          
      </div>
    );
  };

export default WorkshopTeachersOBC;
